import { render, staticRenderFns } from "./index_0.vue?vue&type=template&id=6db073b5&scoped=true"
import script from "./index_0.vue?vue&type=script&lang=js"
export * from "./index_0.vue?vue&type=script&lang=js"
import style0 from "./index_0.vue?vue&type=style&index=0&id=6db073b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db073b5",
  null
  
)

export default component.exports